export function combineStyles(...styles: (string | undefined | false)[]): string {
    return styles.filter((s) => s !== undefined && s !== false).join(' ')
}